import { listOption } from '@/api/base/baseCargo'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(listOption)
